import Wrapper from "../../../layout/Wrapper";
import LifeContractManageComponent from "../../../screens/contractControll/lifeContract/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "insurance Management",
	description: "",
};

export default function AgentManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<LifeContractManageComponent />
		</Wrapper>
	);
}